<template>
  <a-tooltip :title="summary.unread_count ? `有 ${summary.unread_count} 条未读通知` : '通知中心'">
    <a-badge :count="summary.unread_count" :overflow-count="99" class="notification-badge">
      <a-button type="text" class="notification-button" aria-label="通知中心" @click="router.push('/notifications')">
        <BellOutlined />
      </a-button>
    </a-badge>
  </a-tooltip>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { BellOutlined } from '@ant-design/icons-vue';
import { getNotificationSummary } from '../api/notifications';

const router = useRouter();
const summary = reactive({ unread_count: 0, open_count: 0 });
let timer: number | undefined;

const refresh = async () => {
  try {
    const data = await getNotificationSummary();
    summary.unread_count = data.unread_count || 0;
    summary.open_count = data.open_count || 0;
  } catch {
    // Header polling is non-blocking; the notification page surfaces errors.
  }
};

onMounted(() => {
  refresh();
  timer = window.setInterval(refresh, 60_000);
  window.addEventListener('notification-summary-changed', refresh);
});
onBeforeUnmount(() => {
  if (timer) window.clearInterval(timer);
  window.removeEventListener('notification-summary-changed', refresh);
});
</script>

<style scoped>
.notification-badge { line-height: 1; }
.notification-button {
  display: grid;
  width: 38px;
  height: 38px;
  place-items: center;
  color: #344256;
  font-size: 18px;
}
@media (max-width: 767px) {
  .notification-button { color: #d8e4ee; }
  .notification-badge :deep(.ant-badge-count) { box-shadow: 0 0 0 1px #10283f; }
}
</style>
